import Chart from "react-apexcharts";
import { Skeleton, Typography } from "@mui/material";
import { DashCard } from "./DashCard";
import { colors, fontFamily } from "../../data/tokens";
import { NamedSeries } from "./useDashboardData";

// Distribuição de sócios por categoria
export function CategoryBarChart({
  categories,
}: {
  categories: NamedSeries | null;
}) {
  return (
    <DashCard title="Sócios por categoria">
      {!categories ? (
        <Skeleton variant="rounded" height={280} />
      ) : categories.labels.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          Nenhuma categoria cadastrada.
        </Typography>
      ) : (
        <Chart
          type="bar"
          height={300}
          series={[{ name: "Sócios", data: categories.values }]}
          options={{
            chart: { fontFamily, toolbar: { show: false } },
            colors: [colors.primary],
            plotOptions: {
              bar: { horizontal: true, borderRadius: 4, barHeight: "55%" },
            },
            dataLabels: { enabled: false },
            xaxis: { categories: categories.labels },
            grid: { borderColor: colors.neutral200 },
            tooltip: {
              y: { formatter: (v: number) => v.toLocaleString("pt-BR") },
            },
          }}
        />
      )}
    </DashCard>
  );
}
